import React from 'react';

type Row = {
  label: string;
  before: string;
  after: string;
};

const rows: Row[] = [
  {
    label: 'Accès des Tiers',
    before: 'VPN complexe ouvrant une brèche directe vers le réseau interne.',
    after: "Accès via AVD 100% isolé, poste managé dans le cloud, accès limité aux seules applications nécessaires.",
  },
  {
    label: 'Délai de Déploiement',
    before: 'Des semaines, voire des mois, pour connecter et sécuriser 400 utilisateurs.',
    after: 'Prototype fonctionnel (PoC) en quelques heures. Plus de 400 utilisateurs opérationnels en quelques jours.',
  },
  {
    label: 'Modèle de Sécurité',
    before: "Périmètre 'fortifié' classique, inefficace contre menaces internes ou postes compromis.",
    after: "Architecture Zero Trust: authentification multi‑facteurs (MFA), vérification continue et supervision des actions.",
  },
  {
    label: 'Résilience',
    before: 'Une attaque a suffi à paralyser les opérations sur site.',
    after: "Infrastructures sur Azure épargnées. Reprise d'activité en quelques jours grâce au déploiement rapide d'AVD.",
  },
  {
    label: 'Expérience Utilisateur',
    before: "Lenteurs et déconnexions pour les collaborateurs à l'international.",
    after: "Accès fluide et performant partout (Australie, Caraïbes, etc.).",
  },
  {
    label: 'Coûts Opérationnels',
    before: 'Coûts élevés liés aux VM on‑prem et à la maintenance des infrastructures VPN.',
    after: 'Réduction significative des coûts en migrant les anciennes applications sur AVD, scalabilité à la demande.',
  },
];

export default function AVDCaseComparison() {
  return (
    <section aria-labelledby="avd-case-comparison-heading" className="tw-py-10">
      <div className="tw-container tw-mx-auto tw-px-4">
        <div className="tw-max-w-7xl tw-mx-auto">
          <div className="tw-mb-6">
            <h2 id="avd-case-comparison-heading" className="tw-text-xl md:tw-text-2xl tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100">
              Avant / Après : sécuriser le télétravail à l'échelle
            </h2>
            <p className="tw-mt-3 tw-text-sm md:tw-text-base tw-text-gray-700 dark:tw-text-gray-300">
            </p>
          </div>

          {/* Contexte */}
          <div className="tw-mb-6">
            <p className="tw-text-gray-800 dark:tw-text-gray-200 tw-leading-relaxed">
            </p>
          </div>

          {/* Tableau 3 colonnes */}
          <div className="tw-relative tw-overflow-x-auto">
            <table className="tw-min-w-[800px] tw-w-full tw-text-left tw-align-middle">
              <thead>
                <tr>
                  <th scope="col" className="tw-p-3 tw-text-xs md:tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-bg-white dark:tw-bg-neutral-900">
                    Point de Comparaison
                  </th>
                  <th scope="col" className="tw-p-3 tw-text-xs md:tw-text-sm tw-font-semibold tw-text-rose-900 dark:tw-text-rose-100 tw-bg-rose-50 dark:tw-bg-rose-900/30">
                    Leur situation AVANT (Le Risque Permanent)
                  </th>
                  <th scope="col" className="tw-p-3 tw-text-xs md:tw-text-sm tw-font-semibold tw-text-emerald-900 dark:tw-text-emerald-100 tw-bg-emerald-50 dark:tw-bg-emerald-900/30">
                    Leur situation APRÈS
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.label} className="odd:tw-bg-neutral-50 dark:odd:tw-bg-neutral-900/30">
                    <th scope="row" className="tw-align-top tw-p-3 tw-text-[0.92rem] tw-font-medium tw-text-gray-900 dark:tw-text-gray-100">
                      {r.label}
                    </th>
                    <td className="tw-align-top tw-p-3 tw-text-gray-800 dark:tw-text-gray-200">
                      {r.before}
                    </td>
                    <td className="tw-align-top tw-p-3 tw-text-gray-800 dark:tw-text-gray-200">
                      {r.after}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}

